import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: {
        id: '',
        user_name: '',
        contact_number: '',
        email: '',
        role_id: '',
        role_name: '',
        province_id: '',
        province_name: '',
        district_id: '',
        district_name: '',
        tehsil_id: '',
        tehsil_name: '',
        uc_id: '',
        uc_name: '',
        status: '',
        is_available: '',
        accessToken: ''
    },
};

export const authSlice = createSlice({
    name: 'auth',
    initialState: { ...initialState },
    reducers: {
        setAuthState: (state, payload = true) => {
            state.data = payload.payload;
        },
        resetAuthState: (state) => {
            state.data = {...initialState.data};
        },
    },
})

export const { setAuthState, resetAuthState } = authSlice.actions

export default authSlice.reducer